import React from 'react';
import URI from '../../../../defaults/RoutesDefault';
import { Header } from '../../../components/header/HeaderComponent';
import { Button, Breadcrumb } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { pathParam } from '../../../../utilities/Router';
import SecureLink from '../../../components/security/SecureLink';
import { SECURITY_ATTRIBUTE_TYPES } from '../../../context/security';

export default class EmployeeListHeader extends React.Component {
	render(): JSX.Element {
		return (
			<Header>
				<Header.LeftContent>
					<Header.Breadcumbs>
						<Breadcrumb className="breadcrumb-light">
							<Breadcrumb.Item
								linkProps={{ to: URI.contact.employee }}
								linkAs={Link}
							>
								Contacts
							</Breadcrumb.Item>
							<Breadcrumb.Item>Employees</Breadcrumb.Item>
						</Breadcrumb>
					</Header.Breadcumbs>
					<Header.Title>Employees</Header.Title>
				</Header.LeftContent>
				<Header.Actions list={true}>
					<li>
						<SecureLink
							attributeNo={40}
							attributeType={SECURITY_ATTRIBUTE_TYPES.DenyAdd}
							to={pathParam(URI.contact.employeeAdd, {
								tab: 'info',
							})}
							className="btn-icon text-secondary-green btn btn-light btn-lg"
							title="Add Employee"
						>
							<i className="ri-add-line ri-lg"></i> Add
						</SecureLink>
					</li>
				</Header.Actions>
			</Header>
		);
	}
}
